import { FC } from 'react';
import { TAdvanceSearchComponentProps } from './AdvanceSearchComponent.type';
import { renderWithSwitch } from '../../PreferenceComponent';
import './AdvanceSearchComponent.scss';
import { useAppSelector } from '../../../../Hooks/Hooks';
import { RootState } from '../../../../Redux/Store';

const AdvanceSearchComponent: FC<TAdvanceSearchComponentProps> = ({
  content,
  userAlteredData,
  storedPreferences,
  handleChange,
  isAdvanceSearchFilter = false,
  maxMilesError,
}) => {
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const isAdvanceSearch = true;
  const handleCheckboxClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
  };

  const renderWithTooltip = (
    apiKey: string,
    optionType: string,
    defaultValue: string,
    userValue: string,
    contentValue: any,
    handleChange: (type: string, slug: string, value: string, defaultValue?: string) => void,
    isAdvanceSearch: true,
  ) => {
    let updatedValueForPreferredLoadExclusionAccordingToLineOfService;
    if (apiKey === 'preferredLoadExclusion') {
      updatedValueForPreferredLoadExclusionAccordingToLineOfService = contentValue?.filter(
        (_item: any) =>
          _item?.LINE_OF_SERVICE?.includes(
            memberData?.member?.userApplicationDetails?.[0]?.attributes?.LineOfService,
          ),
      );
    }

    return (
      <div className="Content_Item" onClick={handleCheckboxClick}>
        {renderWithSwitch({
          slug: apiKey,
          type: optionType,
          defaultValue: contentValue.some(
            (_item: any) => _item?.OPTION_VALUE === storedPreferences?.[apiKey],
          )
            ? storedPreferences?.[apiKey]
            : defaultValue,
          userSelectedValue: userValue,
          items:
            apiKey === 'preferredLoadExclusion'
              ? updatedValueForPreferredLoadExclusionAccordingToLineOfService?.filter(
                  (_item: any) => _item.GROUP_ORDER_NO === 1,
                )
              : contentValue,
          handleChange,
          isAdvanceSearch,
        })}

        {renderWithSwitch({
          slug: apiKey,
          type: optionType,
          defaultValue: contentValue.some(
            (_item: any) => _item?.OPTION_VALUE === storedPreferences?.[apiKey],
          )
            ? storedPreferences?.[apiKey]
            : defaultValue,
          userSelectedValue: userValue,
          items:
            apiKey === 'preferredLoadExclusion'
              ? updatedValueForPreferredLoadExclusionAccordingToLineOfService?.filter(
                  (_item: any) => _item.GROUP_ORDER_NO === 2,
                )
              : contentValue,
          handleChange,
          isAdvanceSearch,
        })}
        {renderWithSwitch({
          slug: apiKey,
          type: optionType,
          defaultValue: contentValue.some(
            (_item: any) => _item?.OPTION_VALUE === storedPreferences?.[apiKey],
          )
            ? storedPreferences?.[apiKey]
            : defaultValue,
          userSelectedValue: userValue,
          items:
            apiKey === 'preferredLoadExclusion'
              ? updatedValueForPreferredLoadExclusionAccordingToLineOfService?.filter(
                  (_item: any) => _item.GROUP_ORDER_NO === 3,
                )
              : contentValue,
          handleChange,
          isAdvanceSearch,
        })}
      </div>
    );
  };
  if (!content?.length) return null;
  return (
    <div
      className={`AdvanceSearch_Component${isAdvanceSearchFilter ? ' AdvanceSearchFilter' : ''}`}
    >
      <div className="Left_Part">
        {content
          ?.filter((item: any) => item?.DIRECTION === 'left')
          ?.sort((a: any, b: any) => parseInt(a?.SEQUENCE) - parseInt(b?.SEQUENCE))
          .map((contentItem: any) => {
            return (
              <div className={`Content_Item ${contentItem?.API_KEY}`} key={contentItem?.API_KEY}>
                {isAdvanceSearchFilter ? (
                  <p className="Content_Item_Title">{contentItem?.CONTENT_TITLE}</p>
                ) : (
                  contentItem?.CONTENT_TITLE && (
                    <p className="Content_Item_Title">{contentItem?.CONTENT_TITLE}</p>
                  )
                )}
                {contentItem?.CONTENT_SUB_TITLE && (
                  <p className="Content_Item_Subtitle">{contentItem?.CONTENT_SUB_TITLE}</p>
                )}
                {renderWithSwitch({
                  slug: contentItem?.API_KEY,
                  type: contentItem?.OPTION_TYPE,
                  defaultValue: contentItem?.CONTENT_VALUE?.some(
                    (_item: any) =>
                      _item?.OPTION_VALUE === storedPreferences?.[contentItem?.API_KEY],
                  )
                    ? storedPreferences?.[contentItem?.API_KEY]
                    : contentItem?.DEFAULT_VALUE,
                  userSelectedValue: contentItem?.CONTENT_VALUE?.some(
                    (_item: any) => _item?.OPTION_VALUE === userAlteredData[contentItem?.API_KEY],
                  )
                    ? userAlteredData[contentItem?.API_KEY]
                    : undefined,
                  items: contentItem?.CONTENT_VALUE,
                  handleChange,
                  validationError: contentItem?.API_KEY === 'preferredmaxmiles' && !!maxMilesError,
                })}
                {contentItem?.API_KEY === 'preferredmaxmiles' && !!maxMilesError && (
                  <div className="errorMessage">{maxMilesError}</div>
                )}
              </div>
            );
          })}
      </div>
      <div className="Right_Part">
        {content
          ?.filter((item: any) => item?.DIRECTION === 'right')
          ?.sort((a: any, b: any) => parseInt(a?.SEQUENCE) - parseInt(b?.SEQUENCE))
          .map((contentItem: any, index: number) => {
            return (
              <div
                className={`Content_Item ${contentItem?.API_KEY}`}
                key={`${contentItem?.API_KEY} ${index}`}
              >
                <p className="Content_Item_Title">
                  {contentItem?.CONTENT_TITLE?.includes('$1')
                    ? contentItem.CONTENT_TITLE.split('$1').map(
                        (part: any, index: any, array: any) => (
                          <>
                            {part}
                            {index < array.length - 1 && '(Coming Soon)'}
                          </>
                        ),
                      )
                    : contentItem?.CONTENT_TITLE}
                </p>
                {renderWithTooltip(
                  contentItem?.API_KEY,
                  contentItem?.OPTION_TYPE,
                  contentItem?.CONTENT_VALUE?.some(
                    (_item: any) =>
                      _item?.OPTION_VALUE === storedPreferences?.[contentItem?.API_KEY],
                  )
                    ? storedPreferences?.[contentItem?.API_KEY]
                    : contentItem?.DEFAULT_VALUE,
                  userAlteredData[contentItem?.API_KEY],
                  contentItem?.CONTENT_VALUE,
                  handleChange,
                  isAdvanceSearch,
                )}
                {/* Commented below line as it would be enabled in future */}
                {/* {renderWithSwitch(
                    contentItem?.API_KEY,
                    contentItem?.OPTION_TYPE,
                    contentItem?.CONTENT_VALUE?.some(
                      (_item: any) =>
                        _item?.OPTION_VALUE === storedPreferences?.[contentItem?.API_KEY],
                    )
                      ? storedPreferences?.[contentItem?.API_KEY]
                      : contentItem?.DEFAULT_VALUE,
                    userAlteredData[contentItem?.API_KEY],
                    contentItem?.CONTENT_VALUE,
                    handleChange,
                    isAdvanceSearch,
                  )} */}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default AdvanceSearchComponent;
